<template>
<div>
  <headerComponent />
  <div class="Center">
    <div
      class="Wrapper"
      v-if="productInfo">
      <div class="pageTitle">
        <span>商品詳細說明</span>
      </div>
      <h1>{{productInfo.name}}</h1>
      <h2 v-html="productIntroFilter"></h2>

      <div class="block">
        <div class="block-title">
          <label for="">- 商品說明 -</label>
        </div>
        <div
          class="block-content"
          v-html="productDescriptionFilters" />
      </div>

      <div class="block">
        <div class="block-title">
          <label for="">- 商品規格 -</label>
        </div>
        <div class="block-content">
          <iframe id="productSpecIframe" ref="productSpecIframe" :style="{height: productSpecIframeHeight+'px'}" :srcdoc="productSpecFilter"></iframe>
        </div>
      </div>

      <div class="block">
        <div class="block-title">
          <label for="">- 購物須知 -</label>
        </div>
        <div class="block-content">
          <iframe :src="productGuideFilters" marginwidth="0" marginheight="0" class="guide_box"></iframe>
        </div>
      </div>

      <singleBuyItem
        :info="productInfo"
        v-on:addToCart="addToCart"
        v-on:setCartType="setCartType"
        v-on:openBuyItem="openBuyItem"
        v-on:updateCartBuyQuantity="updateCartBuyQuantity"
      />

    </div>

  </div>
  <footerComponent />

  <buyItem
    v-if="showBuyItem"
    v-on:setCartType="setCartType"
    v-on:addToCart="addToCart"
    v-on:hasAdditional="hasAdditional"
    :pid="productInfo.pid"
    :cid="productInfo.cid"
    :defaultQty="cartBuyQty"
    v-on:closeBuyItem="closeBuyItem"
    />
</div>
</template>

<script>
import headerComponent from "../components/common/header.vue";
import footerComponent from "../components/common/footer.vue";
import singleBuyItem from "../components/product/singleBuyItem.vue";
import buyItem from "../components/common/buyitem.vue";

export default {
  name: "Product",
  data() {
    return {
      showBuyItem: false,
      productInfo: null,
      productDescription: '',
      productSpecIframeHeight: 0,
      isAddToCartLoading: false,
      cartType: 1,
      cartBuyQty: 1
    };
  },
  components: {
    headerComponent,
    footerComponent,
    singleBuyItem,
    buyItem
  },
  created() {
    const cid = 0
    let {
      pid
    } = this.$route.query

    // get product info
    const cacheName = `bestshop_product_detail_${pid}_${cid}`
    const cache = this.storage.get(cacheName, true)
    if (cache) {
      this.productInfo = cache
      this.$nextTick(() => {
        this.resizeProductSpecIframe()
      })
    } else {
      this.axios.get(`api/product/${pid}/detail?cid=${cid}`).then(res => {
        const data = res.data;
        if (data.status === 1 && data.data.length > 0) {
          this.productInfo = data.data[0]
          this.storage.set(cacheName, data.data[0], this.configs.webCacheExpireTime, true)
          this.$nextTick(() => {
            this.resizeProductSpecIframe()
          })
        }
      });
    }

    // get product description
    const descCacheName = `bestshop_product_desc_${pid}`
    const descCache = this.storage.get(descCacheName)

    if (descCache) {
      this.productDescription = descCache
    } else {
      this.axios.get(`productDesc?pid=${pid}`).then(res => {
        const data = res.data;
        if (data.response.status === 'OK') {
          this.productDescription = data.payload.productDescVO.strDescDescription
          this.storage.set(descCacheName, data.payload.productDescVO.strDescDescription, this.configs.webCacheExpireTime)
        }
      })
    }

  },
  computed: {
    productIntroFilter() {
      let intro = this.productInfo.intro
      intro = intro.replace(/\\r\\n/ig, '')
      intro = this.tools.replaceWidthAndHeight(intro)
      intro = this.tools.replaceContentTagStyle(intro)
      return intro
    },
    productDescriptionFilters() {
      let content = this.productDescription
      content = this.tools.replaceTplImagePath(content)
      return this.tools.replaceWidthAndHeight(content)
    },
    productSpecFilter() {
      let content = this.productInfo.specification
      content = content.replace(/(width:[\s\d]+px;?)/gi, '')
      content = this.tools.replaceTplImagePath(content)
      content = this.tools.replaceWidthAndHeight(content)
      return content
    },
    productGuideFilters() {
      return `https://${this.configs.subDomain()}.shopping.friday.tw/mobileweb/app/shopping/guide/shopping_guide`
    }
  },
  methods: {
    updateCartBuyQuantity(qty) {
      this.cartBuyQty = qty
    },
    closeBuyItem() {
      // this.$emit("stopBodyScroll", "close");
      this.showBuyItem = false;
    },
    resizeProductSpecIframe() {
      document.querySelector('#productSpecIframe').onload = () => {
        this.productSpecIframeHeight = this.$refs['productSpecIframe'].contentWindow.document.body.scrollHeight
      }
    },
    addToCart(cartItem) {
      if (this.isAddToCartLoading) {
        return;
      }
      this.isAddToCartLoading = true

      if (!this.ec.addToCartBeforeCheck(this.cartType, cartItem)) return

      this.ec.addToCart(cartItem).then(() => {
        this.storage.set("transactionCartType", this.cartType);
        this.isAddToCartLoading = false;
        window.alertMessage = {
          name: 'add-to-cart',
          type: 'success',
          message: '商品加入選購清單成功',
          className: 'friday'
        }
        this.$router.push('/')
      }).catch(data => {
        this.isAddToCartLoading = false;

        const message = new this.fridayMessage({
          name: 'add-to-cart',
          type: 'warning',
          message: `商品加入選購清單失敗,${data.payload.errorUiMsg}`,
          className: 'friday'
        })
        message.init()
        message.show()
      })
    },
    hasAdditional() {

    },
    openBuyItem() {
      this.showBuyItem = true
    },
    setCartType(type) {
      this.cartType = type;
    },
    closeAlertTips() {
      this.showAlert = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.Center {
  text-align: center;

  .Wrapper {
    position: relative;
    width: 950px;
    height: auto;
    margin-top: 20px;
    padding: 35px 75px;
    border-radius: 10px;
    color: #3c3c3c;
    text-align: left;
    background-color: #ffffff;
    box-sizing: border-box;
  }

  .pageTitle {
    display: none;
  }

  h1 {
    font-size: 18px;
    font-weight: 700;
  }

  h2 {
    font-size: 18px;
    font-weight: normal;
    margin-top: 25px;
    margin-bottom: 40px;
  }

  .block {
    border: 1px solid #e0e0e0;
    border-bottom: 0px;

    &:last-child {
      border-bottom: 1px solid #e0e0e0;
    }
  }

  .block-title {
    color: #adadad;
    font-size: 14px;
    text-align: center;
    background-color: #f4f4f4;
    padding: 10px 0;
  }

  .block-content {
    min-height: 100px;
    padding: 1%;
    font-size: 13px;

    iframe {
      border: 0;
      width: 100%;
      height: 300px;
    }
  }
}

@media (max-width: 768px) {
  .Center {
    position: relative;

    .Wrapper {
      width: 100%;
      padding: 0;
      margin: 0;
      border-radius: 0;
    }

    .pageTitle {
      display: block;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
      line-height: 45px;
      text-align: center;

      span {
        font-size: 18px;
        font-weight: 500;
      }
    }

    h1 {
      padding: 10px 15px 0;
      font-size: 1rem;
    }

    h2 {
      margin-top: 0;
      margin-bottom: 10px;
      padding: 10px 15px;
      font-size: 14px;
    }

    .block {
      border: 0;

      .block-content {
        padding: 10px 15px;
      }
    }
  }
}
</style>
